import { createFileRoute, Navigate } from "@tanstack/react-router"
import { MyRoster } from "@/components/crewroster/MyRoster"
import { useCurrentCrewMember } from "@/hooks/useCurrentCrewMember"
import { z } from "zod"

const myRosterSearchSchema = z.object({
  tab: z.enum(["calendar", "list"]).optional().default("calendar"),
  selectedMonth: z.string().optional(),
})

export const Route = createFileRoute("/_auth/profile/roster")({
  validateSearch: myRosterSearchSchema,
  component: ProfileRosterRoute,
})

function ProfileRosterRoute() {
  const { data: currentUser } = useCurrentCrewMember()
  // Crew excluded from scheduling have no roster — send them home.
  if (currentUser?.includeInSchedule === false) {
    return <Navigate to="/home" />
  }
  return <MyRoster />
}
